<template>
	<card>
		<div class="container-fluid" style="min-height: 650px;">
            <div class="row pt-3 pl-2">
				<h5 class="back-title" @click="back()">
					<i class="fa fa-angle-left"></i> Back To Admin
				</h5>
			</div>
            <div class="row mb-4 text-center">
                <div class="col-sm-12">
                    <h4 class="account-title">Group Circuits of {{ siteName }} site</h4>
                </div>
			</div>

            <div class="row mb-5">
                <div class="col-sm-12">
                    <v-client-table
                        :columns="fields"
                        :data="groupCircuits"
                        :options="options"
                        class="text-center"
                    >
                        <template v-slot:actions="props">
                            <button class="filter-action1" @click="deleteGroup(props.row)">
                                <i class="fa fa-remove"></i> Delete Site
                            </button>
                        </template>
                    </v-client-table>
                </div>
            </div>
            <div class="row create-section">
                <div class="col-sm-12 form-group text-center">
                    <label for="name" class="pr-5 text-white">Name &nbsp;</label>
                    <input id="name" type="text" v-model="name" class="user-input" required />
                </div>
                <div class="col-sm-12 mt-4 from-group" style="display: flex; justify-content: center; padding-right: 80px;">
                    <label for="select-circuit" class="pr-5 text-white">Circuits:</label>
                    <multi-select
                        id="select-circuit"
                        ref="multselect"
                        :type="'site-circuits'"
                        :options="channels"
                        @checked="onCheck"
                    ></multi-select>
                </div>
                <div v-if="errorMessages.length > 0"  class="mb-5" style="justify-content: center;text-align: left;">
                    <p v-for="error in errorMessages" style="color: #8D448B !important; display: block;">
                        {{ error }}
                    </p>
                </div>
                <div class="col-sm-12 text-center mt-4 form-group">
                    <button  @click="linkCircuits" class="update-button">
                        Link Circuits
                    </button>
                </div>
			</div>
		</div>
	</card>
</template>

<script>
import Card from "@/components/Cards/Card";
import MultiSelect from "@/components/Inputs/multiSelectInput";
import { consoleLogger } from "@influxdata/influxdb-client";
import { ServerTable, ClientTable, Event } from "vue-tables-2";
import { mapActions, mapGetters } from "vuex";
export default {
	name: 'Edit-Group',
	components: {
		Card,
        MultiSelect
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			user: 'auth/getUser'
		})
	},
	data() {
		return {
			channels: [],
            linkedDevices: [],
            name: '',
            errorMessages: [],
            groupCircuits: [],
            fields: ["name", "group_circuits", "actions"],
            options: {
				headings: {
					name: "name",
                    group: "group_circuits"
				},
				sortable: ["name", "group_circuits"],
				texts: {
					filterPlaceholder: "Search...",
				},
				perPage: 10,
				editableColumns: ["name"],
			},
		}
	},
	watch: {
		repassword(newValue) {
			if (this.password === newValue) {
				this.userError = false;
				this.userMessage = [];
			}
		},
	},
	async created() {
		this.siteId = this.$route.params.id;
		this.siteName = this.$route.params.name;
		let payload = {
			siteId: this.siteId,
			email: this.user.email
		}
        
		let result = await this.getChannels(payload);
		if (result.length > 0) {
            result[0].map(item => {
                if (item['device_type'] != 'Frequency' && item['device_type'] != 'Voltage') {
                    this.channels.push({
                        flag: false,
                        id: item['id'],
                        name: item['device_name'],
                        order: item['device_order']
                    });
                }
            });
		}

        let groupCircuits = await this.getGroupCircuits(this.siteId);

        if (groupCircuits.length > 0) {
            groupCircuits.map(item => {
                this.convertItem(item);
            });
        }
	},
	methods: {
		...mapActions({
			getChannels: "admin/getChannels",
            addGroupCircuits: "admin/addGroupCircuits",
            getGroupCircuits: "admin/getGroupCircuits",
            deleteGroupCircuits: "admin/deleteGroupCircuits"
		}),
        onCheck(val) {
            this.linkedDevices = val;
		},
        back() {
			this.$router.push({ name: "admin" });
		},
		editChannel(channel) {
			this.$router.push({ name: "edit_channel", params: {id: channel.id, channel: channel}});
		},
		back() {
			this.$router.push({name: 'admin'});
		},
        convertItem(item) {
            let devices = JSON.parse(item['devices']);
            let devicesNameString = '';
            if (devices.length > 0) {
                devices.forEach((de, index) => {
                    let channelItem = this.channels.find(c => c['order'] == de);
                    console.log(channelItem);
                    if (channelItem && index != devices.length - 1) {
                        devicesNameString += channelItem['name'] + ", ";
                    } else {
                        devicesNameString += channelItem['name'];
                    }
                })
            }
            
            this.groupCircuits.push({
                name: item['name'],
                group_circuits: devicesNameString,
                id: item['id']
            })
        },
        async deleteGroup(row) {
            console.log(row);
            this.groupCircuits = this.groupCircuits.filter(item => item['id'] != row['id']);
            await this.deleteGroupCircuits(row['id']);
        },
        async linkCircuits() {
            if (this.name == '') {
				this.errorMessages.push("Please input group name");
			}

			if (this.linkedDevices.length <= 1) {
				this.errorMessages.push("Please select more than two circuits");
			}

            if (this.errorMessages.length == 0) {
                let group = {
                    name: this.name,
                    devices: this.linkedDevices,
                    siteId: this.siteId
                }

                try {
                    let result = await this.addGroupCircuits(group);
                    this.$toasted.show("Selected circuits are linked successfully", {
                        type: "success",
                        duration: 2500,
                    });

                    this.convertItem(result[0]);
                    this.linkedDevices = [];
                    this.name = null;
                    this.$refs.multselect.disselectall();
                } catch(err) {
                    console.log(err);
                }
               
            }
        }
	},
}
</script>

<style lang="scss" scoped>

.user-input {
	width: 260px;
    height: 40px;
    border: 1px solid #fdfdfd;
    background-color: #1e365d;
    border-radius: 4px;
    color: white;
}

.update-button {
	width: 120px;
	height: 40px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover {
		background-color: #1f5881;
	}
}

.create-section{
    padding: 30px 40px 20px 40px;
    border: 1px solid;
}
</style>
